import React from 'react';
import moment from 'moment';
import { STUDY_DATE_FORMAT, STUDY_TIME_FORMAT } from '../utils/helper';

interface StudyDateTimeProps {
  value?: string | number | Date | null;
  /**
   * Apply the IST (+05:30) offset. Worklist study/scan/received dates are stored UTC and
   * displayed in IST (default). Tables that already store/show local time pass offset={false}.
   */
  offset?: boolean;
}

/**
 * Stacked date/time table cell — date on top, 24h time below (matches legacy mediff layout,
 * keeps the column narrow).
 */
export const StudyDateTime: React.FC<StudyDateTimeProps> = ({ value, offset = true }) => {
  if (!value) return <span>-</span>;

  const m = offset ? moment(value).utcOffset('+05:30') : moment(value);

  return (
    <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
      <span>{m.format(STUDY_DATE_FORMAT)}</span>
      <span>{m.format(STUDY_TIME_FORMAT)}</span>
    </span>
  );
};

export default StudyDateTime;
